<script>
import { mapMutations } from "vuex";
import auth from "@/logic/auth";
import trs from "@/logic/api/trs";

const token = auth.getToken();
const permissions =
  "EAFI_E_ProcedureCAE,EAFI_E_ProcedureICI,EAFI_E_ProcedureIRE,EAFI_E_ProcedureSEAFI,EAFI_AXE_Recos,EAFI_E_OtherProcedures";

export default {
  name: "UserPermissions",
  methods: {
    ...mapMutations(["SET_USER_PERMISSIONS"]),
    async getAuth(token, permissions) {
      let response = await trs.getAuthorization(token, permissions);
      this.SET_USER_PERMISSIONS(response.data);
    }
  },
  created() {
    this.getAuth(token, permissions);
  },
  render(h) {
    return h();
  }
};
</script>
